@for (subField of fields; track subField) {
  <div fxLayout="row" fxLayoutAlign="space-between">
    <div class="sub-title">
      {{ subField.key }}
    </div>
    <div fxLayout="column">
      @if (!subField.values?.length) {
        <div>(empty)</div>
      }
      @for (valuesObj of subField.values; track valuesObj) {
        <display-data
          [value]="valuesObj.value"
          [dataType]="subField.type"
        ></display-data>
      }
    </div>
  </div>
}
